document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.header-menu__inner .menu-list .child_menu .has_child_menu').forEach(function(menuItem) {
    menuItem.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('.header-menu__inner .menu-list .child_menu .has_child_menu.active').forEach(function(openMenu) {
        if (openMenu !== e.currentTarget) {
          openMenu.classList.remove('active');
        }
      });
      this.classList.toggle('active');
    });
  });
});